import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

const filtersContainerFontSize = 14;

const modalStyle = {
  box: {
    width: '580px'
  }
};

const Container = styled.div`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  color: ${props => props.theme.createOfferAlertModal.primaryTextColor};

  .description {
    line-height: normal;
  }

  .terms-and-conditions {
    opacity: 0.55;
    font-size: ${props => props.theme.rem(filtersContainerFontSize)};

    a {
      color: ${props => props.theme.createOfferAlertModal.linksColor};
      text-decoration: none;
    }
  }
`;

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: ${props => props.theme.space(8)};

  p {
    font-size: ${props => props.theme.rem(filtersContainerFontSize)};
    font-weight: bold;
  }
`;

const RentType = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    height: 40px;

    span {
      font-size: ${props => props.theme.rem(filtersContainerFontSize)};
    }
  }
`;

const Budget = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    padding: 0;
    box-shadow: none;
    margin-top: ${props => props.theme.space(3)};
  }

  ${mediaMin.smallBreakpoint`
    margin-top: ${props => props.theme.space(4)}
  `}
`;

const CommunicationContainer = styled.div`
  margin: ${props => props.theme.space(4)} 0 ${props => props.theme.space(4)};

  > input {
    height: 44px;
    background-color: ${props => props.theme.createOfferAlertModal.inputBackgroundColor};
    border-radius: 0px;
    border: 0px;
    border-bottom: solid 0.5px ${props => props.theme.createOfferAlertModal.inputBorderColor};

    &::placeholder {
      opacity: 0.55;
      color: #667485;
    }
  }

  .label {
    opacity: 0.55;
    font-size: ${props => props.theme.rem(filtersContainerFontSize)};
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  margin-top: ${props => props.theme.space(6)};

  > button {
    width: ${props => props.theme.space(36)};
    height: ${props => props.theme.space(10)};
    margin: 0;

    &:first-child {
      margin-right: ${props => props.theme.space(2)};
    }
  }
`;

export { Container, FiltersContainer, ActionsContainer, CommunicationContainer, RentType, Budget, modalStyle };
